import React from 'react'
import PropTypes from "prop-types";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'

const BackButton = ({ onClick }) => {
    return (
        <button onClick={onClick} className='cursor-pointer flex items-center justify-start gap-[0.5rem]' >
            <FontAwesomeIcon icon={faChevronLeft} size='3x' className='w-[0.7rem] object-contain text-black' />
            <span className='text-[1.2rem]' >Back</span>
        </button>
    )
}

BackButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default BackButton